import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/companies/:creatorId/:companyId/employees']['GET'];

type Input = {
  creatorId: string;
  companyId: string;
  page: number;
  perPage?: number;
};

type Output = ThisApi['response'];

const getCompanyEmployees = async ({ creatorId, companyId, page, perPage }: Input): Promise<Output> => {
  const response = await noodleApiClient.get(`/companies/${creatorId}/${companyId}/employees`, {
    params: {
      page,
      perPage,
    },
  });

  return response.data;
};

export default getCompanyEmployees;
